<script>
export default {
    props: {
        container: {
            type: Boolean,
            default: false
        },

        color: {
            type: String,
            default: 'var(--sustainfinity-blue)'
        },

        text: {
            type: String,
            default: null,
        },

        fontSize: {
            type: String,
            default: '1em',
        },
    }
}
</script>

<template>
    <div>
        <div v-if="container" class="spinner-container">
            <i class="fa-solid fa-spinner" :style="{color: color, fontSize: fontSize}"></i>
            <div v-if="text != null" :style="{color: color, fontSize: fontSize}">
                {{ text }}
            </div>
        </div>
        <i v-else class="fa-solid fa-spinner" :style="{color: color, fontSize: fontSize}"></i>
    </div>
</template>

<style lang='scss' scoped>
    .spinner-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 9999;
    }

    .fa-spinner {
        animation: Spin 500ms linear infinite;
        transform-origin: 50% 50%;
        display: inline-block;
        width: 1em;
        height: 1em;
        line-height: 1em;
        text-align: center;
    }

    @keyframes Spin {
        0% {
            transform: rotate(0);
        } 100% {
            transform: rotate(360deg);
        }
    }
</style>